import React,{useContext} from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';
import {Image} from 'react-bootstrap';

export const Login = () => {

    const {usuario} = useContext(AuthContext);

    if(usuario.logged)
        return <Navigate to="/home" />


    const setLogin = (e) => {
        e.preventDefault()

        const data = {
            usr: e.target.usuario.value,
            pass: e.target.password.value,
            t: '',
        }


        // console.log(JSON.stringify(data))
        const formData = new FormData()
        formData.append( 'usr', e.target.usuario.value )
        formData.append( 'pass', e.target.password.value )
        formData.append( 't', '')
        fetch('REST/controllers/loginController.php?opt=setLogin',{
            method:'post',
            mode:'cors',
            body: formData,
        })
        .then( response => response.json() )
        .then( data => {

            if(data.fork === 'error') {
                alert('Lo sentimos, las credenciales son incorrectas.')
                return false
            } else {
                const d = { logged: true }
                window.location = '/home'
                localStorage.setItem("userAryaAgents", JSON.stringify(d) )
            }
        })
    }


    return (
        <div>

            <nav className={`ws_navbar ws_navbar_fixed `}>
                <div></div>
                <Image
                src={`/img/aryaPRO.png`}
                alt="arya-logo"
                style={{ maxWidth: 250 }}
                />
                <div style={{ cursor: "pointer",color:'#fff' }}>
                    <b>Login</b>
                </div>
            </nav>


            <div className="container-fluid" style={{marginTop:'5rem'}}>
                <div className="row justify-content-center">
                    <div className="col-10 col-md-6 col-lg-4">
                        <div className="tile">
                            <div className="tile-title-w-btn">
                                <h3 className="title text-center" style={{fontWeight:'700'}}>Iniciar sesión</h3>
                            </div>

                            <form id="formPhone" className='mt-4' onSubmit={setLogin}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="control-label mb-2"><b>Usuario</b></label>
                                        <div className='cnt-options'>
                                            <input name="usuario" type="text" placeholder="Ingresa tu nombre de usuario" required />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <label className="control-label mb-2"><b>Contraseña</b></label>
                                        <div className='cnt-options'>
                                            <input name="password" type="password" placeholder="Ingresa tu contraseña" required />
                                        </div>
                                    </div>

                                    <div className="col-md-12" id="divMessageFormPhone"></div>

                                    <div className="col-md-12">
                                        <div className="form-group mt-3">
                                            <button type="submit" className="button ws-btn-secondary"
                                            style={{width:'100%'}} name="btn">Entrar</button>
                                        </div>
                                    </div>

                                </div>
                            </form>

                            <form id="formToken" style={{display:'none'}}>
                                <div className="row">
                                    <div className="col-md-12">
                                            <label className="control-label"><b>Token de acceso</b></label>
                                            <div className='cnt-options'>
                                                <input name="token" type="text" placeholder="Token" required />
                                            </div>
                                            <small>Escribe el token que hemos enviado a tu whatsapp</small>
                                    </div>

                                    <div className="col-md-12" id="divMessageFormToken"></div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <button type="submit" className="button ws-btn-secondary" style={{width:'100%'}} name="btn">Entrar</button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
